import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { applyActionCode } from "firebase/auth";
import { auth } from "../../firebase";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import { useTranslation } from "react-i18next";

const EmailVerificationPage = () => {
  const [searchParams] = useSearchParams();
  const [verified, setVerified] = useState(false);
  const { t } = useTranslation("");

  useEffect(() => {
    const oobCode = searchParams.get("oobCode");

    if (oobCode) {
      applyActionCode(auth, oobCode)
        .then(() => {
          setVerified(true);
        })
        .catch((error) => {});
    } else {
    }
  }, [searchParams]);

  return (
    <>
      <Header />
      <main className="main">
        <div
          className="container py-5 text-center"
          style={{ marginTop: "4rem", marginBottom: "32rem" }}
        >
          <h2 style={{ color: verified ? "green" : "red" }}>
            {verified ? t("titleSuccess") : t("titleError")}
          </h2>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default EmailVerificationPage;
